import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';

@Injectable({
    providedIn: 'root'
})
export class InsightsInfoService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService) {
        super(http, alertService, globalService);
    }

    get(data): Observable<any> {
        return this.getRequest(AppUrl.INSIGHTS, data);
    }

    detail(id): Observable<any> {
        return this.getRequest(AppUrl.INSIGHTS(id));
    }

    create(id, data): Observable<any> {
        return this.postRequest(AppUrl.INSIGHTS_CONTENT(id), data);
    }

    update(id, data): Observable<any> {
        return this.putRequest(AppUrl.INSIGHTS_CONTENT(id), data);
    }

    /*  updateStatus(id, data): Observable<any> {
          return this.putRequest(AppUrl.INSIGHTS_CONTENT_STATUS(id), data);
      }*/


    createByAdmin(id, data): Observable<any> {
        return this.postRequest(AppUrl.INSIGHTS_CONTENT(id), data);
    }

    detailByAdmin(id): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.INSIGHTS(id));
    }

    updateByAdmin(id, data): Observable<any> {
        return this.putRequest(AppUrl.INSIGHTS_CONTENT(id), data);
    }

    getByAdmin(id,data): Observable<any> {
        return this.getRequest(AppUrl.GET_INSIGHTS_CONTENT(id), data);
    }

    faq(id?:any, data?:any):Observable<any>{
        return this.putRequest(AppUrl.INSIGHTS_FAQ(id), data);
    }
}
